import { render, staticRenderFns } from "./studentTipsModal.vue?vue&type=template&id=8d7f99ba&scoped=true"
import script from "./studentTipsModal.vue?vue&type=script&lang=js"
export * from "./studentTipsModal.vue?vue&type=script&lang=js"
import style0 from "./studentTipsModal.vue?vue&type=style&index=0&id=8d7f99ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7f99ba",
  null
  
)

export default component.exports